var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-js vjs-default-skin post-detail-video",attrs:{"id":"audio_player","poster":_vm.returnMedia(_vm.thumbnail),"crossOrigin":"anonymous","playsInline":"","controls":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }